import { useCallback, useEffect, useState } from 'react';
import { useAdminApi, ApiError } from '../../../Admin/shared/adminApi';
import type { ReferredUserDetail } from './types';

export function useReferredUser(userId: string | null) {
  const { request } = useAdminApi();
  const [data, setData] = useState<ReferredUserDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!userId) {
      setData(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      setData(
        await request<ReferredUserDetail>({
          env: 'prod',
          path: `/admin/analytics/referrals/referred/${userId}`,
        }),
      );
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load referred user');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [request, userId]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load };
}
